import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faApple, faGooglePlay } from '@fortawesome/free-brands-svg-icons';
import './AppDownloadCards.scss';

export const APP_DOWNLOADS = [
  {id: 'ios', label: 'Download for iPhone', store: 'App Store', device: 'iPhone & iPad',
    href: 'https://apps.apple.com/app/id1178532514', qr: '/dist/images/app-downloads/app-store-qr.svg', icon: faApple},
  {id: 'android', label: 'Download for Android', store: 'Google Play', device: 'Android',
    href: 'https://play.google.com/store/apps/details?id=com.SquadInTouch.app', qr: '/dist/images/app-downloads/google-play-qr.svg', icon: faGooglePlay}
];

export function AppDownloadCards() {
  return <section className="app-download-cards" aria-label="Install Squad In Touch">
    <header><h3>Get the Squad In Touch app</h3><p>Scan with your phone’s camera, or open your app store below.</p></header>
    <div className="app-download-cards__grid">
      {APP_DOWNLOADS.map(app => <article className="app-download-cards__card" key={app.id}>
        <div className="app-download-cards__platform"><FontAwesomeIcon icon={app.icon} /><div><strong>{app.store}</strong><span>{app.device}</span></div></div>
        <a className="app-download-cards__qr" href={app.href} target="_blank" rel="noopener noreferrer" aria-label={'Open Squad In Touch on ' + app.store}>
          <img src={app.qr} width={160} height={160} alt={'Scan to download Squad In Touch from ' + app.store} />
        </a>
        <a className="app-download-cards__link" href={app.href} target="_blank" rel="noopener noreferrer">{app.label}</a>
      </article>)}
    </div>
  </section>;
}
